export default {
  mailSent: {
    list: [],
    total: 0
  },
  crrMailSent: {}
}
